import { createContext, useContext, type ReactNode } from "react";

import type { Game } from "src/api";

const GameContext = createContext<Game | null>(null);

export function GameProvider({ game, children }: { game: Game; children: ReactNode }) {
  return <GameContext value={game}>{children}</GameContext>;
}

export function useGame(): Game {
  const game = useContext(GameContext);
  if (!game) throw new Error("you need to use the game provider as the root parent");
  return game;
}
